import React, { memo } from 'react';
import { CTAButton } from './Shared';
export const BonusesSection = () => {
  const bonuses = [{
    num: '01',
    icon: '📈',
    title: 'Tablón de Estadísticas Interactivo',
    desc: 'Transformá los resultados y las tablas de posiciones en desafíos matemáticos.',
    includes: ['Registro de resultados', 'Tablas y gráficos', 'Promedios y porcentajes', 'Desafíos de clasificación'],
    price: 'AR$ 14.990'
  }, {
    num: '02',
    icon: '🏟️',
    title: 'Kit Aula Mundialista',
    desc: 'Todo lo necesario para ambientar, motivar y generar pertenencia.',
    includes: ['Banderines', 'Carteles de Fair Play', 'Datos curiosos', 'Pasaporte del Alumno'],
    price: 'AR$ 9.990'
  }, {
    num: '03',
    icon: '🏃',
    title: 'Guía de Recreo Dinámico',
    desc: 'Propuestas para integrar movimiento, salud y trabajo en equipo.',
    includes: ['Hábitos saludables', 'Hidratación', 'Juegos de recreo', 'Desafíos de coordinación'],
    price: 'AR$ 7.990'
  }, {
    num: '04',
    icon: '🏆',
    title: 'Ceremonia de Campeones',
    desc: 'Diplomas y reconocimientos para cerrar el proyecto de forma memorable.',
    includes: ['Campeón de la Lectura', 'Goleador del Compañerismo', 'Gran Investigador Mundial', 'Campeón del Esfuerzo'],
    price: 'AR$ 12.990'
  }];
  return <section className="bg-familia-lightBg py-10 md:py-16 px-4 md:px-6 text-familia-darkText" data-id="element-16">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-17">
        <div className="text-center mb-10 md:mb-12" data-id="element-18">
          <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-extrabold mb-4 text-familia-bg" data-id="element-19">
            🎁 4 BONOS INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-10" data-id="element-20">
          {bonuses.map((b, i) => <div key={i} className="bg-white border border-familia-gold/30 p-5 md:p-6 rounded-2xl relative flex flex-col shadow-sm" data-id="element-21">
              <div className="absolute -top-3 left-6 md:left-8 bg-familia-gold text-white font-bold text-xs py-1 px-4 rounded-full shadow-sm" data-id="element-22">
                BONO {b.num}
              </div>
              <div className="flex items-center gap-4 mb-3 mt-2" data-id="element-23">
                <div className="text-3xl md:text-4xl" data-id="element-24">{b.icon}</div>
                <div data-id="element-25">
                  <h3 className="text-lg md:text-xl font-display font-bold text-familia-bg leading-tight" data-id="element-26">
                    {b.title}
                  </h3>
                </div>
              </div>

              <p className="text-familia-darkGray text-[13px] md:text-sm leading-relaxed mb-4 font-medium" data-id="element-27">
                {b.desc}
              </p>

              <div className="bg-familia-lightSection p-4 rounded-xl mb-5 flex-grow border border-familia-electric/10" data-id="element-28">
                <p className="text-[11px] font-bold text-familia-bg uppercase tracking-wider mb-2" data-id="element-29">
                  Incluye:
                </p>
                <ul className="space-y-1" data-id="element-30">
                  {b.includes.map((item, j) => <li key={j} className="flex items-start gap-2 text-[12px] text-familia-darkGray font-medium" data-id="element-31">
                      <span className="text-familia-green font-bold" data-id="element-32">→</span>
                      <span data-id="element-33">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="flex items-center justify-between pt-3 border-t border-familia-electric/10" data-id="element-34">
                <span className="text-familia-red line-through text-xs font-bold" data-id="element-35">
                  Valor: {b.price}
                </span>
                <span className="text-familia-green font-extrabold text-sm bg-familia-green/10 px-2 py-1 rounded-lg" data-id="element-36">
                  GRATIS ✅
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-familia-bg border-2 border-familia-gold rounded-2xl p-5 md:p-8 text-center max-w-2xl mx-auto shadow-md mb-8" data-id="element-37">
          <p className="text-white/80 text-xs mb-2 font-medium uppercase tracking-wider" data-id="element-38">
            Valor total de los bonos: AR$ 45.960
          </p>
          <div className="bg-familia-gold text-familia-bg font-extrabold py-3 px-5 rounded-xl text-base md:text-lg shadow-inner" data-id="element-39">
            🎁 Hoy los cuatro están incluidos sin costo adicional.
          </div>
        </div>

        <div className="text-center" data-id="element-40">
          <CTAButton href="#precio" className="w-full sm:w-auto text-base px-8 py-4" data-id="element-41">
            QUIERO EL PACK Y LOS 4 BONOS
          </CTAButton>
        </div>
      </div>
    </section>;
};